import { Injectable } from '@angular/core';
import { ServicesGeneralService } from '../servicio-general/servicio-general.service';
import { environmentSelector } from '../../../../environments/environment.selector';

/**
 * Módulo `super-ejecutivo` de pyv-services: puente hacia el Super Ejecutivo, que valida la sesión del usuario
 * (requerimiento `kia-en-kobra-admin`).
 */
@Injectable({
  providedIn: 'root'
})
export class PyvSuperEjecutivoServices extends ServicesGeneralService {
  protected override baseURL: string = environmentSelector().kobraServices.pyvSuperEjecutivo;
  protected override propertie: string = 'pyvSuperEjecutivo';
}
